import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

class ItensApiClient {
	URL_PATH = '/ata-registro-preco/api/public/itemAta'

	async buscarItensPorFiltro(filtro, paginacao) {
		const url = new SearchUrlParamBuilder({
			urlPath: this.URL_PATH,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()
		return await axios.get(url)
	}
}

export default new ItensApiClient()
